import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as callRoutes } from './calls/routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import { routes as crmRoutes } from './crm/routes';
import { routes as schedulingRoutes } from './scheduling/routes';
import { routes as trackingRoutes } from './tracking/routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import OnboardingAccountDetails from './onboarding/Index.vue';
import OnboardingInboxSetup from './onboarding/InboxSetup.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...callRoutes,
        ...contactRoutes,
        ...companyRoutes,
        ...crmRoutes,
        ...schedulingRoutes,
        ...trackingRoutes,
        ...searchRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingAccountDetails,
    },
    {
      path: frontendURL('accounts/:accountId/onboarding/inbox-setup'),
      name: 'onboarding_inbox_setup',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingInboxSetup,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
    {
      path: '/schedule/:slug_or_id',
      name: 'public_scheduling_booking',
      meta: {
        public: true,
      },
      component: () => import('./scheduling/pages/PublicBookingPage.vue'),
    },
    {
      path: '/schedule',
      name: 'public_scheduling_root',
      meta: {
        public: true,
      },
      component: () => import('./scheduling/pages/PublicBookingPage.vue'),
    },
    {
      path: '/portal/profissional',
      name: 'professional_portal_page',
      meta: {
        public: true,
      },
      component: () => import('./scheduling/pages/ProfessionalPortalPage.vue'),
    },
    {
      path: '/portal',
      name: 'professional_portal_root',
      meta: {
        public: true,
      },
      component: () => import('./scheduling/pages/ProfessionalPortalPage.vue'),
    },
  ],
};
